import { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import BaseHeading from "../baseComponents/baseHeading";
import BaseParagraph from "../baseComponents/baseParagraph";
import BaseButton from "../baseComponents/baseButton";
import useBootstrap from "../customHooks/useBootstrap";
import { Container, Row, Col } from "reactstrap";
import useColors from "../customHooks/useColors";

const WithConfirm = (Component) => {

  const NewComponent = (props) => {
    const { trashold4, classes } = useBootstrap();
    const [currentColors] = useColors();

    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmTitle, setConfirmTitle] = useState(null);
    const [confirmText, setConfirmText] = useState(null);

    const [promiseResolveOrReject, setPromiseResolveOrReject] = useState(null);
    const [isContinueInErrorColor, setIsContinueInErrorColor] = useState(false);

    const toogleShow = () => {
      if (showConfirm === false) {
        openConfirm();
      } else {
        closeConfirm(false);
      }
    };

    const openConfirm = ({
      title = null,
      text = null,
      isContinueInErrorColor = false,
    }) => {
      setShowConfirm(true);
      setConfirmTitle(title);
      setConfirmText(text);
      setIsContinueInErrorColor(isContinueInErrorColor);
      return new Promise((resolve, reject) => {
        setPromiseResolveOrReject({
          resolve,
          reject,
        });
      });
    };

    const closeConfirm = (response = false) => {
      setShowConfirm(false);
      if (promiseResolveOrReject) {
        promiseResolveOrReject.resolve({ confirmPressed: response });
        setPromiseResolveOrReject(null);
      }
    };

    return (
      <>
        {showConfirm && (
          <Modal centered isOpen={showConfirm} toggle={toogleShow}>
            <ModalHeader>
              <BaseHeading>{confirmTitle}</BaseHeading>
            </ModalHeader>
            <ModalBody>
              <BaseParagraph>{confirmText}</BaseParagraph>
            </ModalBody>
            <ModalFooter>
              <Container>
                <Row>
                  <Col {...trashold4}></Col>
                  <Col {...trashold4}>
                    <BaseButton
                      onClick={() => {
                        closeConfirm(false);
                      }}
                      hasMarginTop={false}
                    >
                      cancel
                    </BaseButton>
                  </Col>
                  <Col {...trashold4}>
                    
                    <BaseButton
                      hasMarginTop={false}
                      style={{
                        backgroundColor: isContinueInErrorColor
                          ? currentColors.octonary
                          : currentColors.primary,
                      }}
                      onClick={() => {
                        closeConfirm(true);
                      }}
                      cointainerClassName={classes.onOrAboveTrashold.marginTop(
                        true
                      )}
                    >
                      continue
                    </BaseButton>
                  </Col>
                </Row>
              </Container>
            </ModalFooter>
          </Modal>
        )}
        <Component {...props} openConfirm={openConfirm} />
      </>
    );
  };
  return NewComponent;
};

export default WithConfirm;
